import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DownloadFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DownloadFilled({
  title = 'Download',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Download'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M17.3 5h.2c3 0 5.5 2.5 5.5 5.5S20.5 16 17.5 16h-2v-5h-7v5h-2c-3 0-5.5-2.5-5.5-5.5S3.5 5 6.5 5h.2c.7-2.3 2.8-4 5.3-4s4.6 1.7 5.3 4Zm-6.8 14.6V13h3v6.6l3.5-2.3v3.4L12 24l-5-3.3v-3.4l3.5 2.3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DownloadFilled;